import {
  IMediaResource
} from 'modules/common/media/media.types';

export const MEDIA_BLANK: IMediaResource = {
  mediaType: null,
  value: null
}